<template xmlns:el="http://www.w3.org/1999/html">
    <el-container >
      <img :src="loggo" width="100%" height="180px" alt="在线举报">
    <el-header height="175px">

      <p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本产品为休闲娱乐平台，倡导绿色健康游戏！禁止非法组织或个人利用本平台进行赌博等非法盈利行为。一经查实，将封号处理！情节严重者将采取法律手段直接向公安机关汇报进行处理！请广大玩家文明游戏，禁止赌博！
                如果您发现任何违法违规行为，需要提供如下信息材料反馈至我们。我们工作人员会尽快为您核实处理！</p>
    </el-header>
    <el-main>


    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="85px">

      <el-form-item label="举报类型" >
        <el-radio-group v-model="ruleForm.jbtype">
          <el-radio  label="0">赌博</el-radio>
          <el-radio  label="1" >外挂</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input v-model="ruleForm.email" ></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="ruleForm.name" ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input v-model="ruleForm.phone" ></el-input>
      </el-form-item>
     <!-- <el-form-item label="验证码" prop="code">
        <el-input v-model="ruleForm.code" ></el-input>
      </el-form-item>-->

      <el-form-item label="游戏截图(1-5张)"  >
        <el-upload
          ref="gmpics"
          accept="image/*"
          class="upload-demo"
          action="https://qyxx.xmqiyou.com/file/upload"
          :data="{'bucketName':'server'}"
          :before-upload="handleBeforeUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="uploadSuccess"
          list-type="picture-card"
          multiple
          :limit="5"
          :on-exceed="handleExceed"

          >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5MB</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form-item>



      <el-form-item label="证据截图(1-5张)" >
        <el-upload
          ref="zjpics"
          accept="image/*"
          class="upload-demo"
          action="https://qyxx.xmqiyou.com/file/upload"
          :data="{'bucketName':'server'}"
          :before-upload="handleBeforeUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="uploadSuccess"
          list-type="picture-card"
          multiple
          :limit="5"
          :on-exceed="handleExceed"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5MB</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="详细描述" prop="xxdesc">
        <el-input type="textarea" v-model="ruleForm.xxdesc" :rows="7" placeholder="请详细描述：赌博的组织者，参与人数、赌资、方式、玩法、时间、地点，并附相关说明及截图。我们会尽快核实后处理。"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
      </el-form-item>
    </el-form>
    </el-main>
    <el-footer height="150px">
      <div class="footer">
        <span>闽ICP备 19021642</span>
        <span>网络文化许可证:闽网文（2018）3637-169号</span>
        <span>统一社会信用代码:91350206MA31EUL99U</span>
        <span>游戏版号:ISBN978-7-498-05210-0</span>
        <span>电信增值业务许可证:闽B2-20180335</span>
        <span>计算机软件著作权:2017SR542616</span>
      </div>
    </el-footer>
  </el-container>
</template>

<script>

  import loggo from '@/static/imgs/logo.png'

  var checkEmail = (rule, value, cb) => {
    //验证邮箱的正则表达式
    const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
    if(regEmail.test(value)) {
      //合法的邮箱
      return cb()
    }
    cb(new Error('请输入合法的邮箱'))
  }

  var checkMobile = (rule, value, cb) => {
    //验证手机号的正则表达式
    const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    if(regMobile.test(value)) {
      //合法的手机号
      return cb()
    }
    cb(new Error('请输入合法的手机号'))
  }

  export default {
    data() {
      return {
        loggo: loggo,
        dialogImageUrl: '',
        dialogVisible: false,
        ruleForm:{
          jbtype: '0',
          email: '',
          name: '',
          phone: '',
          code: '',
          xxdesc: '',
          gmpics: [],
          zjpics: []
        },
        rules:{
          email: [
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            { validator: checkEmail, trigger: 'blur' }
          ],
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { validator: checkMobile, trigger: 'blur' }
          ],
        /*  code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],*/
          xxdesc:[
            { required: true, message: '请输入描述', trigger: 'blur' },
          ]
        }
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var params=this.$refs[formName].model;
            params['gmpics']=this.$refs.gmpics.uploadFiles;
            params['zjpics']=this.$refs.zjpics.uploadFiles;
            this.$axios.post('https://qyxx.xmqiyou.com/jb/add', params)
              .then(function (response1) {
                var response=response1.data;
                if(response.code=='000000'){
                  //状态码为200时则上传成功
                  alert(`提交成功`);
                  location.reload();
                }else{
                  alert(response.mesg);
                }
              });
            return true;
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      },
      handleBeforeUpload(file) {
        const uploadLimit = 5
        const uploadTypes = ['jpg', 'png','jpeg']
        const filetype = file.name.replace(/.+\./, '')
        const isRightSize = (file.size || 0) / 1024 /1024  < uploadLimit
        if (!isRightSize) {
          this.$message.error('文件大小超过 ' + uploadLimit + 'MB')
          return false
        }
        if (uploadTypes.indexOf(filetype.toLowerCase()) === -1) {
          this.$message.warning({
            message: '请上传后缀名为jpg、png的图片'
          })
          return false
        }
        return true
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      //上传成功
      uploadSuccess(response,file,fileList){
        console.log(response)
        if(response.code=='000000'){
          //状态码为200时则上传成功
          file.response = response.data;
        }else{
          //状态码不是200时上传失败 从列表中删除
          file.status = 'fail';
          fileList.splice(fileList.indexOf(file),1);
          this.$message.warning(response.mesg);
        }
      },
    }
  }
</script>

<style scoped>

  .upload-demo{
    text-align: left;
  }

  .el-header {
    background-color: #4a4a4b;
    color: #ee0606;
    text-align: left;
    line-height: 100px;
  }

  .el-footer {
      background-color: #4a4a4b;
      color: #ee0606;
      text-align: left;
      line-height: 100px;
    }

  .footer{
    margin-top: -30px;
  }

  .footer  span{
    word-break:normal;
    width:auto;
    display:block;
    white-space:pre-wrap;
    word-wrap : break-word ;
    text-align: center;
    height: 20px;
  }

  .el-aside {
    background-color: #e5e7ea;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    background-color: #e9edf1;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/hsmj/jb.vue